import { createFileRoute } from "@tanstack/react-router";
import { MinerUConfig } from "@client/components/settings/parse-engine";

export const Route = createFileRoute("/_app/settings/parser")({
  component: MinerUConfig,
});
